module.exports = __webpack_public_path__ + "static/media/LogoMosaic.b948a64c.svg";